import { STARTER_PILLS } from "../starterPills";

// Quick starts under Courtney's greeting. Tapping one sends its message.
// Shown from the moment the chat opens (below the typing indicator, then below
// her greeting) until the user sends, taps or starts a call.
export function StarterChips({
  avatarUrl,
  onPick,
}: {
  avatarUrl?: string;
  onPick: (message: string) => void;
}) {
  return (
    // Indented under the agent bubbles (avatar width + gap) when there is one.
    <div className={`lk-widget-starter-chips${avatarUrl ? " lk-widget-starter-chips--indented" : ""}`}>
      {STARTER_PILLS.map((pill) => (
        <button
          key={pill.label}
          type="button"
          className="lk-widget-starter-chip"
          onClick={() => onPick(pill.message)}
        >
          <pill.Icon size={16} weight="regular" />
          <span>{pill.label}</span>
        </button>
      ))}
    </div>
  );
}

// Pure so it's testable. The chips are for the empty chat only: they go away
// once the user has done anything (sent, queued or tapped something, or gone to
// voice), and are never offered on the ended screen (ConversationFeedback has
// its own quick starts). Courtney's own greeting does NOT hide them.
export function showStarterChips({
  conversationEnded,
  userHasActed,
}: {
  conversationEnded: boolean;
  userHasActed: boolean;
}): boolean {
  return !conversationEnded && !userHasActed;
}
